module.exports = __webpack_public_path__ + "img/191017 Hotspot tablet rules.ff27b881.png";